import { connect } from "react-redux";

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Typography from '@mui/material/Typography';
import clsx from "clsx";
import { makeStyles } from 'tss-react/mui';
import { Theme247 } from "../styles/Theme247";
import { isValidElement } from "react";

const IconText = (props) => {
  /*
  * Styles
  */
  const useStyles = makeStyles()((theme) => ({
    iconTextContainer: {
      display: 'inline-block',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    iconStyle: {
      display: 'inline-block',
      color: props.textcolor,
      marginRight: 0.35 * props.size,
      transform: props.iconStyle ? "" : 'translateY(0.25em)',

      '& .mdi-icon, & .MuiSvgIcon-root': {
        width: 16,
        height: 16,
      }
    },
    captionStyle: {
      ...Theme247.typography.small_caption,
      color: props.textcolor,
      lineHeight: props.size/10,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  }));

  const {classes} = useStyles();

  return(
    <div className={ clsx( 'iconTextContainer', classes.iconTextContainer, classes.style, props?.className )} style={props.style}>
      { props?.icon ? <span className={ classes.iconStyle } >{props?.icon}</span> : false }
      <span className={ classes.captionStyle }>{ isValidElement(props.text) ? props.text : <Typography variant="caption" className={ classes.captionStyle } style={{color: props.textColor, marginLeft: (window.location.pathname.includes("machine-overview") || window.location.pathname.includes("notifications-dashboard")) ? "5px" : "0px"}}>{props.text}</Typography>}</span>
      { props.right ?
        <Typography variant="caption" className={ classes.captionStyle } >{props.right}</Typography> : false
      }
    </div>
  );
};


export default connect(({isAuthUser, i18n}) => ({isAuthUser, i18n}), {})(IconText);
